import React from 'react'
import { useQuery } from '@apollo/client/react'
import {
  Grid,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@mui/material'
import bgNewLarge from '@/assets/images/bgNewLarge.png'
import { GET_SUBSCRIPTION_PLAN } from './queries'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

const numberFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export default function PlanSelectionCard({
  section,
  activeTab,
  currencyFormat,
  setSelectedPlan,
  setTab,
}) {
  const subscriptionPlanId =
    activeTab === 'Monthly' ? section.nameMonthly : section.nameYearly

  const { loading, data } = useQuery(GET_SUBSCRIPTION_PLAN, {
    variables: { subscriptionPlan: subscriptionPlanId },
  })

  if (loading)
    return (
      <Grid size={{ sm: 4 }}>
        <LoadingSkeleton variant="plan" />
      </Grid>
    )

  const { subscriptionPlan = {} } = data || {}

  return (
    <Grid size={{ sm: 4 }}>
      <Card
        style={{
          margin: 10,
          textAlign: 'center',
          backgroundColor: section.label === 'Growth' && '#8ab8f9',
          backgroundImage:
            section.label === 'Pro' ? 'url(' + bgNewLarge + ')' : '',
          borderStyle: section.label === 'Pro' && 'solid',
          borderWidth: section.label === 'Pro' && 'thick',
          borderColor: section.label === 'Pro' && '#ffd000',
          borderRadius: 5,
          boxShadow: '0 4px 10px 0 #bbbbbb',
          minWidth: 300,
        }}
      >
        <Grid
          container
          direction="column"
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Grid>
            <Typography
              variant="subtitle1"

              style={{
                marginBottom: -5,
                color: section.label === 'Pro' ? 'white' : 'black',
              }}
              sx={{
                fontWeight: 300,
                textTransform: 'uppercase',
                mt: '1.5rem',
              }}
            >
              {activeTab === 'Monthly'
                ? section.subHeaderMonthly
                : section.subHeaderYearly}
            </Typography>
          </Grid>
          <Grid>
            <Typography
              style={{
                backgroundColor:
                  section.label === 'Pro' ? '#ffd000' : 'lightGrey',
                borderRadius: 5,
                fontWeight: 600,
                marginTop: 10,
                paddingBottom: 5,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 5,
              }}
            >
              {section.label}
            </Typography>
          </Grid>
          <Typography
            variant="h4"
            color="primary"

            sx={{ fontWeight: 700, textTransform: 'uppercase' }}
          ></Typography>
        </Grid>
        <CardContent
          style={{
            color: section.label === 'Pro' ? 'white' : 'black',
          }}
        >
          <Grid
            container
            direction="column"
            spacing={2}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid>
              {(section.groupCoaching ||
                section.personalizedCoaching) && (
                <Typography
                  variant="subtitle1"
                  style={{
                    paddingTop: 0,
                  }}
                >
                  1x{' '}
                  {section.personalizedCoaching
                    ? 'Personal'
                    : 'Group'}{' '}
                  Coaching Fee then
                </Typography>
              )}
              <Typography
                variant="h3"

                style={{
                  marginBottom: -25,
                }}
                sx={{ fontWeight: 700 }}
              >
                {currencyFormat.format(
                  activeTab === 'Monthly' ||
                    section.nameMonthly === section.nameYearly
                    ? subscriptionPlan.price / 100
                    : subscriptionPlan.price / 100 / 12,
                )}
                {section.nameMonthly !== 'group-coaching' &&
                  section.nameMonthly !== 'personalized-coaching' &&
                  '*'}
              </Typography>
            </Grid>
            {section.label !== 'Free' && (
              <Grid>
                <Typography
                  variant="subtitle1"
                  style={{
                    paddingTop: 0,
                  }}
                >
                  {activeTab === 'Monthly' ||
                  section.nameMonthly === section.nameYearly
                    ? 'PER MONTH'
                    : `${currencyFormat.format(
                        subscriptionPlan.price / 100,
                      )} PER YEAR`}
                </Typography>
              </Grid>
            )}
          </Grid>
          <Divider
            color="white"
            style={{
              marginTop: 10,
              marginBottom: 20,
            }}
          />
          <Grid
            container
            direction="column"
            spacing={2}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {section.personalizedCoaching && (
              <Grid>
                <Typography>
                  {section.personalizedCoaching}
                </Typography>
              </Grid>
            )}
            {section.groupCoaching && (
              <Grid>
                <Typography>{section.groupCoaching}</Typography>
              </Grid>
            )}
            {section.label !== 'Free' ? (
              <Grid>
                <Typography>
                  Analyze{' '}
                  <b>
                    {numberFormat.format(
                      subscriptionPlan.propertyCount,
                    )}
                  </b>{' '}
                  Properties/mo
                </Typography>
              </Grid>
            ) : (
              <Grid
                style={{
                  marginTop: 30,
                }}
              >
                <Typography>
                  *Analyze <b>{section.properties}</b> Properties/mo
                </Typography>
              </Grid>
            )}
            <Grid>
              <Typography>
                Create up to{' '}
                <b>{subscriptionPlan.porfolioCount || 1}</b> portfolio
              </Typography>
            </Grid>
            {section.label !== 'Investor' && (
              <Grid>
                <Typography>
                  Add <b>{subscriptionPlan.teamCount || 0}</b> team
                  members
                </Typography>
              </Grid>
            )}
            <Grid>
              <Typography>{section.search}</Typography>
            </Grid>
            <Grid>
              <Typography>{section.analyze}</Typography>
            </Grid>
            <Grid>
              <Typography>{section.comp}</Typography>
            </Grid>
            {section.housefoliosMarketplace && (
              <Grid>
                <Typography>
                  {section.housefoliosMarketplace}
                </Typography>
              </Grid>
            )}
            {subscriptionPlan.marketplaceCount > 0 &&
              subscriptionPlan.marketplaceCount && (
                <Grid>
                  <Typography>
                    Create <b>{subscriptionPlan.marketplaceCount}</b>{' '}
                    Marketplace websites
                  </Typography>
                </Grid>
              )}
            {section.prioritized && (
              <>
                <Grid>
                  <Typography>{section.prioritized}</Typography>
                </Grid>
                <Grid>
                  <Typography>{section.access}</Typography>
                </Grid>
                <Grid>
                  <Typography>{section.exclusive}</Typography>
                </Grid>
                <Grid>
                  <Typography>{section.listVerified}</Typography>
                </Grid>
                <Grid>
                  <Typography>{section.earlyAccess}</Typography>
                </Grid>
              </>
            )}
          </Grid>
          <Grid
            size={12}
            style={{
              marginTop: 10,
            }}
          >
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              style={{
                fontWeight: 600,
                backgroundColor: 'white',
              }}
              onClick={() => {
                setSelectedPlan(
                  activeTab === 'Monthly'
                    ? section.nameMonthly
                    : section.nameYearly,
                )
                setTab(2)
              }}
            >
              Get Started
            </Button>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}
